module.exports = __webpack_public_path__ + "static/media/herbal.6f4fb9ea.svg";